import Core from '@mediaplatform/sportal365-football-sdk-v2';
import { FINISHED } from '../constants/statusTypes';
import { H2HFilters } from '../../apps/football/src/widgets';
import { getOddsSettings } from '@sportal365/smp-widget-utils';
import { IFootballMatchApi, OddFormat, ScopeTypes } from '../types';

export default (sdk: Core): IFootballMatchApi => {
  const getMatchById: IFootballMatchApi['getMatchById'] = ({
    signal,
    dataMatchId,
    dataOddsDisplay,
    dataOddsBettingId,
    dataOddsMarket,
    dataOddsPreEventOnly = false,
    dataOddsMarketValueType = OddFormat.DECIMAL,
    dataOddsScopeType = ScopeTypes.ALL,
    dataSingleEventMainEventsDisplay = false,
    dataDisplayLineupStatus = false,
  }) => {
    if (dataMatchId) {
      const match = sdk.match(dataMatchId);

      if (dataOddsDisplay) {
        match.withOdds(
          getOddsSettings(dataOddsBettingId, dataOddsMarket, dataOddsMarketValueType, dataOddsPreEventOnly, dataOddsScopeType),
        );
      }

      if (dataSingleEventMainEventsDisplay) {
        match.withDisplayMainEvents();
      }

      if (dataDisplayLineupStatus) {
        match.withLineupsStatus();
      }

      return match.get({ signal });
    }

    console.warn('No match is provided');
  };

  const getGroupedMatchesH2H: IFootballMatchApi['getGroupedMatchesH2H'] = ({
    signal,
    dataSportEntityOne,
    dataSportEntityTwo,
    dataLimit,
  }) => {
    if (dataSportEntityOne && dataSportEntityTwo) {
      const matchesH2H = sdk
        .matchesH2H({
          teamIds: [dataSportEntityOne, dataSportEntityTwo],
          limit: Number(dataLimit),
          statusTypes: FINISHED,
        })
        ?.groupByTournament();

      // TS detects it as different models and we need to parse it
      // as any and then re-format it to monorepo's interface.
      return matchesH2H?.extractTeams()?.get({ signal }) as any;
    }

    console.warn('No sport entities are provided');
  };

  const getMatchesH2H: IFootballMatchApi['getMatchesH2H'] = ({ signal, dataLimit, filter, teamId }) => {
    if (filter && teamId) {
      const teamIds = filter !== H2HFilters.H2H ? [teamId] : [];

      const matchesH2H = sdk.matchesH2H({
        teamIds,
        limit: Number(dataLimit),
        statusTypes: FINISHED,
      });

      // TS detects it as different models and we need to parse it
      // as any and then re-format it to monorepo's interface.
      return matchesH2H?.get({ signal }) as any;
    }

    console.warn('No sport entities are provided');
  };

  return { getMatchById, getGroupedMatchesH2H, getMatchesH2H };
};
